import React, { useState } from "react";
import Modal, { modalStyles as m } from "./Modal";
import { fmt } from "../uiUtils";

// Android customItemTaxForCustomItemDialog (CustomTaxListAdapter): when the CUSTOM_CATEGORY register
// flag is OFF the cashier picks the taxes for a custom item — every store tax as a checkbox,
// DefaultTax pre-checked — plus an "Allow EBT" checkbox (shown only when ALLOW_CUSTOM_ITEM_EBT is
// on). Done → the item is added with the checked taxes and the EBT choice.
export default function CustomItemTaxModal({ amount, taxes, showAllowEbt, onDone, onClose }) {
  const list = Array.isArray(taxes) ? taxes : [];
  const [checked, setChecked] = useState(() => new Set(list.filter((t) => t.title === "DefaultTax").map((t) => String(t.id))));
  const [allowEbt, setAllowEbt] = useState(false);
  const toggle = (id) =>
    setChecked((s) => {
      const n = new Set(s);
      const k = String(id);
      if (n.has(k)) n.delete(k);
      else n.add(k);
      return n;
    });

  return (
    <Modal title="Custom Item" onClose={onClose}>
      <div style={m.label}>Amount</div>
      <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.01em", margin: "4px 0 12px" }}>{fmt(amount)}</div>
      <div style={m.label}>Select Tax</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 260, overflow: "auto" }}>
        {list.length === 0 && <div style={{ color: "var(--ink-3)", padding: 8 }}>No taxes configured</div>}
        {list.map((t) => (
          <label key={t.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", border: "1px solid var(--line)", borderRadius: 10, cursor: "pointer" }}>
            <input type="checkbox" checked={checked.has(String(t.id))} onChange={() => toggle(t.id)} />
            <span style={{ fontWeight: 500 }}>{t.displayname || t.displayName || t.title}</span>
            <span style={{ marginLeft: "auto", color: "var(--ink-2)" }}>{String(t.percent).trim()}%</span>
          </label>
        ))}
      </div>
      {showAllowEbt && (
        <>
          <div style={{ ...m.label, marginTop: 12 }}>Benefit program</div>
          <label style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", border: "1px solid var(--line)", borderRadius: 10, cursor: "pointer" }}>
            <input type="checkbox" checked={allowEbt} onChange={(e) => setAllowEbt(e.target.checked)} />
            <span style={{ fontWeight: 500 }}>Allow EBT</span>
          </label>
        </>
      )}
      <button style={m.primary} onClick={() => onDone({ taxes: list.filter((t) => checked.has(String(t.id))), allowEbt })}>Done</button>
      <button style={m.ghost} onClick={onClose}>Cancel</button>
    </Modal>
  );
}
